import { JSONSchema7 } from 'json-schema';

const DraftClosedDeadlineColumnSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'DraftClosedDeadlineColumnSchema',
        type: 'object',
        //
        definitions: {},
    };
    //
    schema = {
        properties: {
            className: {
                type: 'string',
            },
        },
        //
        ...schema,
    };
    //
    return schema;
};

export default DraftClosedDeadlineColumnSchema;
